import React from "react"
import { Link } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"
// import logo from "../../assets/img/location/kataliklogo.png"
import { YMaps, Map, Placemark } from "react-yandex-maps"

import {
  citySwitchAddress,
  citySwitchMapCenter,
  citySwitchMapLink,
  citySwitchTelNumber,
  citySwitchTelNumberCut,
  citySwitchTelNumberStr,
} from "../requisites"

export default function Footer({ city }) {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-row">
          <div className="footer-col">
            <div className="footer-col-header">ССЫЛКИ</div>
            <ul className="footer-col-list">
              <li className="footer-col-list__item">
                <Link to="/" className="footer-col-list__link">
                  Главная
                </Link>
              </li>
              <li className="footer-col-list__item">
                <AnchorLink to="/#price" className="footer-col-list__link">
                  Цены
                </AnchorLink>
              </li>
              <li className="footer-col-list__item">
                <AnchorLink to="/#company" className="footer-col-list__link">
                  О нас
                </AnchorLink>
              </li>
              <li className="footer-col-list__item">
                <AnchorLink to="/#location" className="footer-col-list__link">
                  Пункты приема
                </AnchorLink>
              </li>
              <li className="footer-col-list__item">
                <AnchorLink to="/#dostavka" className="footer-col-list__link">
                  Условия
                </AnchorLink>
              </li>
              <li className="footer-col-list__item">
                <Link to="/article" className="footer-col-list__link">
                  Статьи
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-col footer-col-socials">
            <div className="footer-col-header">СОЦИАЛЬНЫЕ СЕТИ</div>
            <ul className="footer-col-list">
              <li className="footer-col-list__item">
                <a
                  href="https://vk.com/katalikauto/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-col-list__link d-flex align-items-center social-icon"
                >
                  <div className="footer-col-list__icon">
                    <svg
                      fill="black"
                      enableBackground="new 0 0 24 24"
                      height="512"
                      viewBox="0 0 24 24"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m19.915 13.028c-.388-.49-.277-.708 0-1.146.005-.005 3.208-4.431 3.538-5.932l.002-.001c.164-.547 0-.949-.793-.949h-2.624c-.668 0-.976.345-1.141.731 0 0-1.336 3.198-3.226 5.271-.61.599-.892.791-1.225.791-.164 0-.419-.192-.419-.739v-5.105c0-.656-.187-.949-.74-.949h-4.126c-.419 0-.668.306-.668.591 0 .622.945.765 1.043 2.515v3.797c0 .832-.151.985-.486.985-.892 0-3.057-3.211-4.34-6.886-.259-.713-.512-1.001-1.185-1.001h-2.625c-.749 0-.9.345-.9.731 0 .682.892 4.073 4.148 8.553 2.17 3.058 5.226 4.715 8.006 4.715 1.671 0 1.875-.368 1.875-1.001 0-2.922-.151-3.198.686-3.198.388 0 1.056.192 2.616 1.667 1.783 1.749 2.076 2.532 3.074 2.532h2.624c.748 0 1.127-.368.909-1.094-.499-1.527-3.871-4.668-4.023-4.878z" />
                    </svg>
                  </div>
                  <div className="footer-col-list__text">ВКонтакте</div>
                </a>
              </li>
              <li className="footer-col-list__item">
                <a
                  href="https://ok.ru/group/63420602384423"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-col-list__link d-flex align-items-center social-icon"
                >
                  <div className="footer-col-list__icon">
                    <svg
                      fill="black"
                      enableBackground="new 0 0 24 24"
                      height="512"
                      viewBox="0 0 24 24"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m4.721 12.881c-.613 1.205.083 1.781 1.671 2.765 1.35.834 3.215 1.139 4.413 1.261-.491.472 1.759-1.692-4.721 4.541-1.374 1.317.838 3.43 2.211 2.141l3.717-3.585c1.423 1.369 2.787 2.681 3.717 3.59 1.374 1.294 3.585-.801 2.226-2.141-.102-.097-5.037-4.831-4.736-4.541 1.213-.122 3.05-.445 4.384-1.261l-.001-.001c1.588-.989 2.284-1.564 1.68-2.769-.365-.684-1.349-1.256-2.659-.267 0 0-1.769 1.355-4.622 1.355-2.854 0-4.622-1.355-4.622-1.355-1.309-.994-2.297-.417-2.658.267z" />
                      <path d="m11.999 12.142c3.478 0 6.318-2.718 6.318-6.064 0-3.36-2.84-6.078-6.318-6.078-3.479 0-6.319 2.718-6.319 6.078 0 3.346 2.84 6.064 6.319 6.064zm0-9.063c1.709 0 3.103 1.341 3.103 2.999 0 1.644-1.394 2.985-3.103 2.985s-3.103-1.341-3.103-2.985c-.001-1.659 1.393-2.999 3.103-2.999z" />
                    </svg>
                  </div>
                  <div className="footer-col-list__text">Одноклассники</div>
                </a>
              </li>
              <li className="footer-col-list__item">
                <a
                  href="https://www.instagram.com/katalikauto/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-col-list__link d-flex align-items-center social-icon"
                >
                  <div className="footer-col-list__icon">
                    <svg
                      fill="black"
                      enableBackground="new 0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      xmlSpace="preserve"
                    >
                      <g>
                        <g>
                          <path d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160 C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48 h192c61.76,0,112,50.24,112,112V352z" />
                        </g>
                      </g>
                      `
                      <g>
                        <g>
                          <path d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336 c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z" />
                        </g>
                      </g>
                      <g>
                        <g>
                          <circle cx="393.6" cy="118.4" r="17.056" />
                        </g>
                      </g>
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                    </svg>
                  </div>
                  <div className="footer-col-list__text">Instagram</div>
                </a>
              </li>
              <li className="footer-col-list__item">
                <a
                  href="https://www.facebook.com/katalikauto"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-col-list__link d-flex align-items-center social-icon"
                >
                  <div className="footer-col-list__icon">
                    <svg
                      fill="black"
                      enableBackground="new 0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      xmlSpace="preserve"
                    >
                      <g>
                        <g>
                          <path d="M288,176v-64c0-17.664,14.336-32,32-32h32V0h-64c-53.024,0-96,42.976-96,96v80h-64v80h64v256h96V256h64l32-80H288z" />
                        </g>
                      </g>
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                    </svg>
                  </div>
                  <div className="footer-col-list__text">Facebook</div>
                </a>
              </li>
              <li className="footer-col-list__item">
                <a
                  href="https://www.youtube.com/channel/UCQJfUF1sm45EzsSS8VvyGUQ"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-col-list__link d-flex align-items-center social-icon"
                >
                  <div className="footer-col-list__icon">
                    <svg
                      fill="black"
                      enableBackground="new 0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      xmlSpace="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M490.24,113.92c-13.888-24.704-28.96-29.248-59.648-30.976C399.936,80.864,322.848,80,256.064,80
			                c-66.912,0-144.032,0.864-174.656,2.912c-30.624,1.76-45.728,6.272-59.744,31.008C7.36,138.592,0,181.088,0,255.904
			                C0,255.968,0,256,0,256c0,0.064,0,0.096,0,0.096v0.064c0,74.496,7.36,117.312,21.664,141.728
			                c14.016,24.704,29.088,29.184,59.712,31.264C112.032,430.944,189.152,432,256.064,432c66.784,0,143.872-1.056,174.56-2.816
			                c30.688-2.08,45.76-6.56,59.648-31.264C504.704,373.504,512,330.688,512,256.192c0,0,0-0.096,0-0.16c0,0,0-0.064,0-0.096
			                C512,181.088,504.704,138.592,490.24,113.92z M192,352V160l160,96L192,352z"
                          />
                        </g>
                      </g>
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                    </svg>
                  </div>
                  <div className="footer-col-list__text">YouTube</div>
                </a>
              </li>
              <li className="footer-col-list__item">
                <a
                  href="https://www.tiktok.com/@katalikauto"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-col-list__link d-flex align-items-center social-icon"
                >
                  <div className="footer-col-list__icon">
                    <svg
                      fill="black"
                      enableBackground="new 0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      height="800"
                      width="1200"
                      viewBox="-4.15362 -7.827075 35.99804 46.96245"
                      xmlSpace="preserve"
                    >
                      <g xmlns="http://www.w3.org/2000/svg" fill="none">
                        <path
                          fill="#25F4EE"
                          d="M10.7908 12.33v-1.22a9.003 9.003 0 00-1.28-.11C5.36 10.9912 1.685 13.681.4387 17.6403c-1.2465 3.9592.2248 8.269 3.632 10.6397-2.5522-2.7315-3.2609-6.708-1.8094-10.153 1.4514-3.445 4.792-5.7155 8.5295-5.797z"
                        />
                        <path
                          fill="#25F4EE"
                          d="M11.0208 26.15c2.3207-.0031 4.2284-1.8315 4.33-4.15V1.31h3.78a7.09 7.09 0 01-.11-1.31h-5.17v20.67c-.086 2.3303-1.9981 4.1762-4.33 4.18a4.3996 4.3996 0 01-2-.5 4.34 4.34 0 003.5 1.8zm15.17-17.82V7.18a7.06 7.06 0 01-3.91-1.18 7.17 7.17 0 003.91 2.33z"
                        />
                        <path
                          fill="#FE2C55"
                          d="M22.2808 6a7.12 7.12 0 01-1.77-4.7h-1.38a7.16 7.16 0 003.15 4.7zm-12.77 10.17c-1.9916.0102-3.7206 1.3746-4.1936 3.3092-.473 1.9346.4314 3.9428 2.1936 4.8708a4.33 4.33 0 013.51-6.87c.434.0054.865.0728 1.28.2v-5.26a9.0809 9.0809 0 00-1.28-.1h-.23v4a4.45 4.45 0 00-1.28-.15z"
                        />
                        <path
                          fill="#FE2C55"
                          d="M26.1908 8.33v4a12.2701 12.2701 0 01-7.17-2.33v10.51c-.011 5.2444-4.2656 9.49-9.51 9.49a9.4097 9.4097 0 01-5.44-1.72c2.6562 2.8568 6.79 3.7972 10.4207 2.3706 3.6306-1.4267 6.0184-4.9297 6.0193-8.8306V11.34a12.29 12.29 0 007.18 2.3V8.49a7.3297 7.3297 0 01-1.5-.16z"
                        />
                        <path
                          fill="#000"
                          d="M19.0208 20.51V10a12.27 12.27 0 007.18 2.3v-4a7.17 7.17 0 01-3.92-2.3 7.16 7.16 0 01-3.15-4.7h-3.78V22c-.0756 1.8468-1.3126 3.443-3.082 3.9772-1.7695.5342-3.683-.1108-4.768-1.6072-1.7622-.928-2.6666-2.9362-2.1936-4.8708.473-1.9346 2.202-3.299 4.1936-3.3092a4.451 4.451 0 011.28.2v-4c-3.7585.0637-7.1243 2.342-8.5799 5.8077-1.4555 3.4657-.726 7.464 1.8599 10.1923a9.41 9.41 0 005.45 1.61c5.2444 0 9.499-4.2456 9.51-9.49z"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="footer-col-list__text">TikTok</div>
                </a>
              </li>
              <li className="footer-col-list__item">
                <Link
                  to="/politika-konfidenczialnosti"
                  className="footer-col-list__link d-flex align-items-center social-icon"
                >
                  <div className="footer-col-list__text">
                    Политика <br />
                    конфиденциальности
                  </div>
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-col footer-col-contacts">
            <div className="footer-col-header">КОНТАКТЫ</div>
            <ul className="footer-col-list">
              <li className="footer-col-list__item">
                ООО "ДДС-Групп"
                <br /> ОГРН 1214000000587
              </li>
              <li className="footer-col-list__item">
                <span>Пн-Пт</span> 10:00-19:00, <span>Сб</span> 10:00-14:00
              </li>
              <li className="footer-col-list__item">
                {citySwitchAddress(city)}
              </li>
              <li className="footer-col-list__item">
                <a
                  href="mailto:katalikauto@yandex.ru"
                  className="footer-col-list__link"
                >
                  katalikauto@yandex.ru
                </a>
              </li>
              <li className="footer-col-list__item">
                <a href="tel:88002506625" className="footer-col-list__link">
                  <span>8 (800) 250-66-25</span>
                </a>
                (звонок беспл.)
              </li>
              <li className="footer-col-list__item footer-col-icons-row">
                <a
                  href={`tel:${citySwitchTelNumber(city)}`}
                  className="footer-col-list__link"
                >
                  <span>{citySwitchTelNumberStr(city)}</span>
                </a>
                <div className="footer-col-list__messagers">
                  <a
                    href={`whatsapp://send?phone=${citySwitchTelNumberCut(
                      city
                    )}`}
                    aria-label="Написать в WhatsApp"
                    className="footer-col-list__messager social-icon"
                  >
                    <svg
                      height="682pt"
                      viewBox="-23 -21 682 682.66669"
                      width="682pt"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0"
                        fillRule="evenodd"
                      />
                    </svg>
                  </a>
                  <a
                    href={`viber://chat?number=${citySwitchTelNumberCut(city)}`}
                    aria-label="Написать в Viber"
                    className="footer-col-list__messager social-icon"
                  >
                    <svg
                      enableBackground="new 0 0 24 24"
                      height="512"
                      viewBox="0 0 24 24"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="#8e24aa">
                        <path d="m23.155 13.893c.716-6.027-.344-9.832-2.256-11.553l.001-.001c-3.086-2.939-13.508-3.374-17.2.132-1.658 1.715-2.242 4.232-2.306 7.348-.064 3.117-.14 8.956 5.301 10.54h.005l-.005 2.419s-.037.98.589 1.177c.716.232 1.04-.223 3.267-2.883 3.724.323 6.584-.417 6.909-.525.752-.252 5.007-.815 5.695-6.654zm-12.237 5.477s-2.357 2.939-3.09 3.702c-.24.248-.503.225-.499-.267 0-.323.018-4.016.018-4.016-4.613-1.322-4.341-6.294-4.291-8.895.05-2.602.526-4.733 1.93-6.168 3.239-3.037 12.376-2.358 14.704-.17 2.846 2.523 1.833 9.651 1.839 9.894-.585 4.874-4.033 5.183-4.667 5.394-.271.09-2.786.737-5.944.526z" />
                        <path d="m12.222 4.297c-.385 0-.385.6 0 .605 2.987.023 5.447 2.105 5.474 5.924 0 .403.59.398.585-.005h-.001c-.032-4.115-2.718-6.501-6.058-6.524z" />
                        <path d="m16.151 10.193c-.009.398.58.417.585.014.049-2.269-1.35-4.138-3.979-4.335-.385-.028-.425.577-.041.605 2.28.173 3.481 1.729 3.435 3.716z" />
                        <path d="m15.521 12.774c-.494-.286-.997-.108-1.205.173l-.435.563c-.221.286-.634.248-.634.248-3.014-.797-3.82-3.951-3.82-3.951s-.037-.427.239-.656l.544-.45c.272-.216.444-.736.167-1.247-.74-1.337-1.237-1.798-1.49-2.152-.266-.333-.666-.408-1.082-.183h-.009c-.865.506-1.812 1.453-1.509 2.428.517 1.028 1.467 4.305 4.495 6.781 1.423 1.171 3.675 2.371 4.631 2.648l.009.014c.942.314 1.858-.67 2.347-1.561v-.007c.217-.431.145-.839-.172-1.106-.562-.548-1.41-1.153-2.076-1.542z" />
                        <path d="m13.169 8.104c.961.056 1.427.558 1.477 1.589.018.403.603.375.585-.028-.064-1.346-.766-2.096-2.03-2.166-.385-.023-.421.582-.032.605z" />
                      </g>
                    </svg>
                  </a>
                  <a
                    href="tg://resolve?domain=Andrey_Kaluga"
                    aria-label="Написать в Telegram"
                    className="footer-col-list__messager social-icon"
                  >
                    <svg
                      id="Bold"
                      enableBackground="new 0 0 24 24"
                      height="512"
                      viewBox="0 0 24 24"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m9.417 15.181-.397 5.584c.568 0 .814-.244 1.109-.537l2.663-2.545 5.518 4.041c1.012.564 1.725.267 1.998-.931l3.622-16.972.001-.001c.321-1.496-.541-2.081-1.527-1.714l-21.29 8.151c-1.453.564-1.431 1.374-.247 1.741l5.443 1.693 12.643-7.911c.595-.394 1.136-.176.691.218z" />
                    </svg>
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <div className="footer-col footer-col-map" id="footer-col-map">
            <div className="footer-col-map-layout">
              <a
                href={citySwitchMapLink(city)}
                target="_blank"
                rel="noreferrer"
                className="footer-col-map-layout__link"
              >
                Проложить маршрут
              </a>
            </div>

            <YMaps>
              <Map
                defaultState={{ center: citySwitchMapCenter(city), zoom: 12 }}
                style={{ width: "100%", height: "295px" }}
              >
                <Placemark geometry={citySwitchMapCenter(city)} />
              </Map>
            </YMaps>
          </div>
        </div>
        <div className="footer-copyright">
          © 2020-2021 КаталикАвто Все материалы данного сайта являются объектами
          авторского права. Запрещается копирование, распространение (в том
          числе путем копирования на другие сайты и ресурсы в Интернете) или
          любое иное использование информации и объектов без предварительного
          согласия правообладателя.
        </div>
      </div>
    </footer>
  )
}
